import * as React from "react";
import { Card, CardHeader, CardContent, Chip, Stack, Typography, Box } from "@mui/material";
import { UserFitnessStatus } from "../../../types/models/UserFitnessStatus";
import { getStatusColor, getStatusDisplayname, getStatusIcon } from "../../../utils/FitForWorkUtil";
import EmptyResult from "../../rules/EmptyResult";

interface FitForWorkDetailProp {
  userFitness?: UserFitnessStatus;
}

export function FitForWorkDetail({ userFitness }: FitForWorkDetailProp) {
  if (userFitness && userFitness.StatusKey) {
    return (
      <Card variant="elevation" sx={{ borderTop: "1px solid lightgray" }}>
        <CardHeader
          title={
            <Stack direction="row" alignItems="center" spacing={1}>
              <Chip
                label={getStatusDisplayname(userFitness.StatusKey)}
                color={getStatusColor(userFitness.StatusKey)}
                size="medium"
                icon={getStatusIcon(userFitness.StatusKey)}
              />
            </Stack>
          }
        />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            Latest assessment: <strong>{userFitness.Status}</strong>
          </Typography>
        </CardContent>
      </Card>
    );
  } else {
    return (
      <Box sx={{ py: 4, borderTop: "1px solid lightgray" }}>
        <EmptyResult>There is currently no fitness data available</EmptyResult>
      </Box>
    );
  }
}
